import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ELearningService} from '../../../../core/services/e-learning.service';
import {ToastrService} from 'ngx-toastr';
import {FuseConfigService} from '../../../../core/services/config.service';
import {NgxSpinnerService} from 'ngx-spinner';
import {TranslateService} from '@ngx-translate/core';
import { FuseDeleteDialogComponent } from '../../../../core/components/delete-dialog/delete-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { RecommendedEventModal } from '../../events/recommend-event-modal/recommend-event.component';
import { Location } from '@angular/common';
import { SubscriptionService } from '../../../../core/services/subscription.service';

@Component({
  selector: 'el-preview',
  templateUrl: './elearning-preview.component.html',
  styleUrls: ['./elearning-preview.component.scss'],
  standalone: false
})

export class ElearningPreview implements OnInit {
  id;
  public = false;
  elearning;

  constructor(public elService: ELearningService, public route: ActivatedRoute,
              public toastr: ToastrService,
              private translate: TranslateService,
              private fuseConfig: FuseConfigService, private spinner: NgxSpinnerService,
              public dialog: MatDialog, private location: Location,
              private subscriptionService: SubscriptionService) {
    this.id = this.route.snapshot.queryParamMap.get('id');
  }

  ngOnInit() {
    if (this.id) {
      this.getDetail();
    }
  }

  getDetail() {
    this.spinner.show();
    this.elService.getELearningById(this.id).subscribe((res: any) => {
      if (res) {
        if (res.questions) {
          res.questions = this.elService.atobUtf8(res.questions);
        }
        this.elearning = res;
      }
      this.spinner.hide();
    });
  }

  createRecommendation() {
    const dialogRef = this.dialog.open(RecommendedEventModal , {
      width: '500px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let data = {
          elearningId: this.id,
          recommendation_text: result
        };
        this.elService.addRecommendation(data).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('event.recommendation_created');
            this.toastr.success(msg, title);
            this.elearning.recommendationCreated = true;
            this.elearning.canRemoveRecommendation = true;
            this.elearning.recommendationId = res.id;
          }
        });
      }
    });
  }

  removeRecommendation() {
    let title = this.translate.instant('event.remove_recommendation');
    let msg = this.translate.instant('event.remove_recommendation_confirm');
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: title , message: msg}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.elService.removeRecommendation(this.elearning.recommendationId).subscribe((res: any) => {
          if (res) {
            let title = this.translate.instant('successfully');
            let msg = this.translate.instant('event.recommendation_removed');
            this.toastr.success(msg, title);
            this.elearning.recommendationCreated = false;
            delete this.elearning.recommendationId;
          }
        });
      }
    });
  }
  back() {
    this.location.back();
  }

  unsubscribeElearning() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'blog.unsubscribe' , message: 'blog.unsubscribe_question'}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subscriptionService.deleteElearningSubscription(this.id).subscribe((res: any) => {
          this.back();
        })
      }
    });
  }
}
